export default __webpack_public_path__ + "static/media/avax.80e97652.png";